import { IND_LLP_TASK_GROUP_TO_EMAIL_MAP } from './IN_INCORP/IN_LLP/ind-llp';
import { IND_PVT_LTD_TASK_GROUP_TO_EMAIL_MAP } from './IN_INCORP/IN_PVT_LTD/ind-pvt-ltd';
import { EmailTemplate } from './types';
import { US_CCORP_TASK_GROUP_TO_EMAIL_MAP } from './US_INCORP/CCORP/config';
import { US_LLC_TASK_GROUP_TO_EMAIL_MAP } from './US_INCORP/LLC/config';

export const SERVICE_REQUEST_CATALOG_TO_EMAIL_MAP: Record<
  string,
  Record<string, EmailTemplate | null>
> = {
  EM_INC_IN_LLP: IND_LLP_TASK_GROUP_TO_EMAIL_MAP,
  EM_INC_IN_PVTLTD: IND_PVT_LTD_TASK_GROUP_TO_EMAIL_MAP,
  EM_INC_US_LLC: US_LLC_TASK_GROUP_TO_EMAIL_MAP,
  EM_INC_US_CCORP: US_CCORP_TASK_GROUP_TO_EMAIL_MAP,
};
